import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { MaterialModule } from './imports/material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatNativeDateModule } from '@angular/material/core';

import { components } from './components';
import { directives } from './directives';
import { pipes } from './pipes';
import { FormDateRangePickerComponent } from './components/dynamic-form/components/form-date-range-picker/form-date-range-picker.component';
import { UserDashboardComponent } from './components/user-dashboard/user-dashboard.component';
import { VideoEmbedViewerComponent } from './components/video-embed-viewer/video-embed-viewer.component';
import { DynamicTitleComponent } from './components/dynamic-title/dynamic-title.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { GenericPillButtonComponent } from './components/generic-pill-button/generic-pill-button.component';
import { ClassroomViewComponent } from './components/classroom-view/classroom-view.component';
import { TextSizeDirective } from './directives/text-size.directive';
import { PageSelectorComponent } from './components/page-selector/page-selector.component';
import { UnitGradingListPresentationComponent } from '@app/features/teacher/grading/unit-grading/unit-grading-view/unit-grading-list-presentation.component';
import { UnitGradingListSmartComponent } from '@app/features/teacher/grading/unit-grading/unit-grading-view/unit-grading-list-smart.component';
import { SharedStudentQuizBlockComponent } from './components/student-quiz-block/student-quiz-block.component';
import { component as gradeUnitComponents } from './grade-unit/grade-unit-routing.module';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';

/**
 * Connects modules, pipes, directives, components, dependencies, and more that do not need to be singleton instances.
 */
@NgModule({
  imports: [
    CommonModule,
    CKEditorModule,
    MaterialModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MatButtonToggleModule,
    MatBadgeModule,
  ],
  exports: [
    CommonModule,
    MaterialModule,
    CKEditorModule,
    ReactiveFormsModule,
    gradeUnitComponents,
    components,
    directives,
    pipes,
  ],
  providers: [],
  declarations: [
    components,
    gradeUnitComponents,
    directives,
    pipes,
    FormDateRangePickerComponent,
    UserDashboardComponent,
    VideoEmbedViewerComponent,
    DynamicTitleComponent,
    SharedStudentQuizBlockComponent,
    GenericPillButtonComponent,
    ClassroomViewComponent,
    TextSizeDirective,
    PageSelectorComponent,
    UnitGradingListPresentationComponent,
    UnitGradingListSmartComponent,
  ],
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
    };
  }
}
